import React from 'react';
import { connect } from 'react-redux';
import { dispatch } from '@rematch/core';
import { Route, withRouter } from 'react-router-dom';
import SplitContainer from '@zippytech/react-toolkit/SplitContainer'
import '@zippytech/react-toolkit/SplitContainer/index.css'
import { history } from '../../../helpers';
import BaseCategory from './Drive/BaseCategory'
import Category from './Drive/Category'
import SubCategory from './Drive/SubCategory'
import WSBrowserPane from "./BrowserPane/wsBrowserPane";
import './wsSetting.css';
import CategoryListingCard from '../../drive/Categories/CategoryListingCard';
import IntegrationSetting from './DesignerPane/IntegrationSetting'
import AllIntegrations from './DesignerPane/AllIntegrations'
import WorkspaceMetaData from './DesignerPane/WorkspaceMetaData';
import EmailTemplateListing from './DesignerPane/EmailTemplateListing'
import PublicLibrarySetting from './DesignerPane/PublicLibrarySetting'
import NewEmailTemplate from './Drive/emailTemplate/NewEmailTemplate'
import GlobalEmailForm from './Drive/emailTemplate/GlobalEmailForm'
import LoginAccessSetting from './DesignerPane/LoginAccessSetting';
class WSSetting extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      splitAt: "-40%",
      browserPaneSplit: "25%",
      collapsedResourcePaneIndex: null,
    }
  }


  componentDidMount() {
    dispatch.organizationTab.getCurrentOrganizationData(this.props.selectedOrganisation.id);
    dispatch.integrations.getIntegrations()
    dispatch.workspaceMetaData.getMetaData()
  }

  componentWillMount() {
    dispatch.app.setCurrentContext("ws-setting");
    dispatch.community.setMainAreaContext("baseCategory");
    dispatch.categories.getAllCategories({ organizationId: this.props.match.params.workspaceId })
  }

  render() {
    return (
      <SplitContainer bordered
        orientation="vertical"
        minSize="10%"
        maxSize={['50%', null]}
        fillSides={[true, true]}
        collapsible={[true, false]}
        defaultSplitAt="25%"
        resizeProxy={true}
      >
        <SplitContainer.Side className="setOverflow " >
          <WSBrowserPane {...this.props} />
        </SplitContainer.Side>

        <SplitContainer.Side className="pad_20" style={{ height: "100%", overflow: 'auto' }} >
          {/* <Route exact path="/app/:accountId/_ws/:workspaceId/_wsSetting" render={() => (<DesignerIndex  {...this.props} />)} /> */}
          <Route exact path="/app/:accountId/_ws/:workspaceId/_wsSetting" render={() => (<CategoryListingCard  {...this.props} level="workspace" levelDepth="baseCategory" />)} />
          <Route exact path="/app/:accountId/_ws/:workspaceId/_wsSetting/categories" render={() => (<CategoryListingCard  {...this.props} level="workspace" levelDepth="baseCategory" />)} />
          <Route exact path="/app/:accountId/_ws/:workspaceId/_wsSetting/categories/:baseCategoryId" render={() => (<CategoryListingCard  {...this.props} level="workspace" levelDepth="category" />)} />
          <Route exact path="/app/:accountId/_ws/:workspaceId/_wsSetting/categories/:baseCategoryId/:categoryId" render={() => (<CategoryListingCard  {...this.props} level="workspace" levelDepth="subCategory" />)} />
          <Route exact path="/app/:accountId/_ws/:workspaceId/_wsSetting/integrations" render={() => (<AllIntegrations  {...this.props} level="workspace" />)} />
          <Route exact path="/app/:accountId/_ws/:workspaceId/_wsSetting/integrations/:interigationId" render={() => (<IntegrationSetting  {...this.props} level="workspace" />)} />
          <Route exact path="/app/:accountId/_ws/:workspaceId/_wsSetting/emailTemplates/listing" render={() => (<EmailTemplateListing  {...this.props} />)} />
          <Route exact path="/app/:accountId/_ws/:workspaceId/_wsSetting/metaData" render={() => (<WorkspaceMetaData {...this.props}/>)} />   {/* Workspace metadata KLM-8948 */} 
          <Route exact path="/app/:accountId/_ws/:workspaceId/_wsSetting/emailTemplates/email/:templateId" render={() => (<NewEmailTemplate  {...this.props} />)} />
          <Route exact path="/app/:accountId/_ws/:workspaceId/_wsSetting/emailTemplates/global" render={() => (<GlobalEmailForm  {...this.props} />)} />
          <Route exact path="/app/:accountId/_ws/:workspaceId/_wsSetting/generalSetting/listing" render={() => (<div>Select an option from the General Settings list</div>)} />        
          <Route exact path="/app/:accountId/_ws/:workspaceId/_wsSetting/generalSetting/publicLibrary" render={() => (<PublicLibrarySetting  {...this.props} />)} />
          <Route exact path="/app/:accountId/_ws/:workspaceId/_wsSetting/generalSetting/loginAccess" render={() => (<LoginAccessSetting  {...this.props} />)} />
        </SplitContainer.Side>

      </SplitContainer>
    );
  }
}

function mapStateToProps(state) {

  return {
    user: state.app.user,
    categoryTree: state.lifeCycle.categoryTree,
    selectedAccount: state.app.selectedAccount,
    selectedOrganisation: state.app.selectedOrganisation,
    allCategoryList: state.categories.allCategoryList,
    categoryTreeById: state.categories.categoryTreeById,
    isDeleteCategoryModalOpen: state.account.isDeleteCategoryModalOpen,
    isAddCategoryModalOpen: state.account.isAddCategoryModalOpen,
    selectedCategory: state.account.selectedCategory,
    routeParams: state.app.routeParams,
    envData: state.app.envData,
    catagoryAttachedDetails: state.categories.catagoryAttachedDetails,
    selectedIntegration: state.integrations.selectedIntegration,
    testResult: state.integrations.testResult,
    testInProgress: state.loading.effects.integrations.testIntegration && state.loading.models.integrations,
    currentOrganization: state.organizationTab.currentOrganization,
    integrationsList: state.integrations.integrationsList,
    customNotificationArray: state.customTemplates.customNotificationArray,
    globalTemplate: state.customTemplates.globalTemplate,
    customNotificationRuleName: state.customTemplates.customNotificationRuleName,
    customNotificationCondition: state.customTemplates.customNotificationCondition,
    workspaceMetaData: state.workspaceMetaData.wspaceMetadata,  // Added for workspace metadata KLM-8948
    categoryListLoader: state.categories.categoryListLoader,
    selectedTemplateUsed: state.customTemplates.selectedTemplateUsed,
  };
}

const connectedActivitiesDesignerPage = connect(mapStateToProps)(WSSetting)

export { connectedActivitiesDesignerPage as WSSetting };
